




import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityService } from 'app/shared/service/entity.service';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { StatutNotification } from './statut-notification.model';

@Injectable()
export class StatutNotificationService extends EntityService<StatutNotification> {

    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
    }
}